<template>
  <div
    v-bind:aria-labelledby="labelElementId"
    aria-modal="true"
    v-bind:class="dialogClassList"
    v-bind:id="dialogElementId"
    role="dialog"
    v-on-leave="emitCancel">
    <button
      aria-label="Закрыть диалог"
      class="side-dialog__close-button"
      v-on:click="emitCancel"
      type="button" />
    <h3
      class="side-dialog__caption"
      v-bind:id="labelElementId">{{ label }}</h3>
    <slot />
  </div>
</template>
<script>

/**
 * @description Позиция диалога по умолчанию.
 * @type {string}
 */
const DEFAULT_PLACEMENT = 'right';
const DEFAULT_SIZE = 'normal';

/**
 * @description Название события отмены.
 * @type {string}
 */
const NAME_EVENT_CANCEL = 'cancel';

/**
 * @description Компонент бокового диалога.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Классы родительского элемента.
     * @type {function(Vue): string[]}
     */
    dialogClassList: ({ placement, size }) => [
      'side-dialog',
      `side-dialog_${placement}`,
      `side-dialog_${size}`,
    ],
    /**
     * @description Идентификатор родительского элемента.
     * @type {function(): string}
     */
    dialogElementId: () => 'side-dialog',
    /**
     * @description Идентификатор элемента заголовка.
     * @type {function(): string}
     */
    labelElementId: () => 'side-dialog-label',
  },
  directives: {
    onLeave: {
      inserted(el, binding, { context }) {
        const keyupListener = (event) => {
          if (
            event.code === 'Escape'
            && (event.target instanceof HTMLBodyElement
              || context.$el.contains(window.document.activeElement))
          ) {
            binding.value(context);
          }
        };
        window.document.addEventListener('keyup', keyupListener);
        context.$once('hook:destroyed', () => window.document.removeEventListener('keyup', keyupListener));
      },
    },
  },
  methods: {
    /**
     * @description Отправить событие закрытия диалога.
     * @returns {void}
     */
    emitCancel() {
      this.$emit(NAME_EVENT_CANCEL);
    },
  },
  props: {
    /**
     * @description Текст заголовка.
     * @type {string}
     */
    label: {
      required: true,
      type: String,
    },
    /**
     * @description Название позиции окна.
     * @type {string}
     */
    placement: {
      default: DEFAULT_PLACEMENT,
      type: String,
      validator: (input) => [DEFAULT_PLACEMENT, 'left'].indexOf(input) !== -1,
    },
    /**
     * @description Ширина side-dialog.
     * @type {string}
     */
    size: {
      default: DEFAULT_SIZE,
      type: String,
      validator: (input) => [DEFAULT_SIZE, 'small', 'auto'].indexOf(input) !== -1,
    },
  },
};
</script>
<style scoped lang="scss">
.side-dialog {
  background-color: #fff;
  box-shadow: var(--shadow-layer-right);
  width: 100% !important;
  padding: 22px 27px 50px 27px;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  z-index: 5;
  &_left {
    left: 0;
  }
  &_right {
    right: 0;
  }
  &_normal {
    max-width: 640px;
  }
  &_small {
    max-width: 450px;
  }
  &_auto {
    max-width: max-content;
    overflow: hidden;
  }
  &__close-button {
    position: absolute;
    right: 10px;
    top: 10px;
    background-image: url("@/assets/img/exit-black.svg");
    background-position: center;
    background-size: auto;
    background-repeat: no-repeat;
    background-color: #eaeff3;
    padding: 9px;
    border-radius: 2px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 3;
    &:hover {
      background-color: transparent;
    }
  }
  &__caption {
    font-family: "PT Sans", sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
    margin: 0;
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 860px) {
  .side-dialog {
    &_auto {
      max-width: 100%;
      padding: 0;
      top: 0;
    }
  }
}

@media screen and (max-width: 700px) {
  .side-dialog {
    top: 54px;
    &_auto {
      top: 0;
    }
  }
}
</style>
